import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  GET_VENDOR_IMPERSONATION_STATE,
  SET_IS_IMPERSONATION_SESSION_EXPIRED,
} from "../redux/slices/impersonationSlice";
import useBrowserWindowActivity from "./useBrowserWindowActivity.hook";
import { StoreType } from "../redux/StoreType";
import { GET_USER_STATE } from "../redux/slices/userSlice";

const useImpersonationCookieWatcher = () => {
  const dispatch = useDispatch();
  const { isBrowserWindowActive } = useBrowserWindowActivity();

  const {
    user: { isVendorAdmin },
  }: StoreType = useSelector(GET_USER_STATE, shallowEqual);
  const {
    impersonation: { isVendorImpersonationSet },
  }: StoreType = useSelector(GET_VENDOR_IMPERSONATION_STATE, shallowEqual);

  useEffect(() => {
    let intervalId: number | undefined;

    if (isVendorAdmin && isBrowserWindowActive && isVendorImpersonationSet) {
      intervalId = window.setInterval(() => {
        if (!document.cookie.includes("ImpersonatingUser")) {
          dispatch(SET_IS_IMPERSONATION_SESSION_EXPIRED());
        }
      }, 1000);
    }

    return () => window.clearInterval(intervalId);
  }, [
    isVendorAdmin,
    isBrowserWindowActive,
    isVendorImpersonationSet,
    dispatch,
  ]);
};

export default useImpersonationCookieWatcher;
